// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ba95c908","977":"5a6f77b0"}[chunkId] + ".chunk.js";
};